import _ from 'lodash';
import TenantHero from '../models/TenantHero';

/**
 *
 * the expected heroes array contains hero arrays of strings
 * with the following structure:
 *
 * [ id, name, email, popins, reach, lastPopin ]
 *
 */

export const HeroSorts = {

  /**
   * @param {Array<any>} heroes list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByName (heroes, reversed = false) {
    const result = _.sortBy(heroes, u => TenantHero.getName(u).toLowerCase());
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} heroes list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByEmail (heroes, reversed = false) {
    const result = _.sortBy(heroes, u => TenantHero.getEmail(u).toLowerCase());
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} heroes list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByPopins (heroes, reversed = false) {
    const result = _.sortBy(heroes, u => TenantHero.getPopins(u));
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} heroes list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByReach (heroes, reversed = false) {
    const result = _.sortBy(heroes, u => TenantHero.getReach(u));
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} heroes list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByLastPopin (heroes, reversed = false) {
    const result = _.sortBy(heroes, u => {
      const lastTime = TenantHero.getLastPopin(u);
      if (!lastTime) {
        return 0;
      } else {
        return lastTime;
      }
    });
    return reversed ? _.reverse(result) : result;
  }

};
